import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from "../../context/store";
import { useHistory } from "react-router-dom";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import AssetDetailsDrawer from "./components/AssetDetailsDrawer";
import AssetSearchPanel from "./components/AssetSearchPanel";
import BuildingNavigator from "./components/BuildingNavigator";
import { DRAWER_BACKGROUND } from "../../constants/styles";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export default function Matterport() {

  const globalState = useContext(store);
  const history = useHistory();
  const viewerRef = useRef(null);
  const SDK_KEY = "3t70s1i468hwhswcc3saftgma";
  
  
  const [assetOpen, setAssetOpen] = useState(false);
  const [assetCode, setAssetCode] = useState(null);
  const [searchAsset, setSearchAsset] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  
  useEffect(function () {
    const iframe = viewerRef.current;
    if (!iframe) return;

    window.MP_SDK.connect(iframe, SDK_KEY, "3.0")
      .then(function (sdk) {

        console.log("SDK connected");

        window.mpSdk = sdk; // 🔥 IMPORTANT

        sdk.on(sdk.Mattertag.Event.CLICK, function (tagSid) {

          sdk.Mattertag.getData().then(function(tags){

            const tag = tags.find(function(t){
              return t.sid === tagSid;
            });

            openAssetDrawer(tagSid);

          });

        });

      });
  }, []);
	 
	 
	 /*
	    * Teleport camera to asset
	    */
	   useEffect(function(){

	     if(!searchAsset) return;
	     if(!window.mpSdk) return;

	     setTimeout(function(){

	       window.mpSdk.Sweep.moveTo("qh6mtg3gstcuan328kznn84ha");

	       setTimeout(function(){

	         window.mpSdk.Camera.rotate(187, 0);
	 		setTimeout(() => {setAssetOpen(true)}, 4000);
	       },400);

	     },1800);

	   },[searchAsset]);
	 
	const openAssetDrawer = (code) => {
		setAssetCode(code);
		  setAssetOpen(true);
	}


  // ---------------- STYLES ----------------

  const pageContainer = {
    position: "relative",
    minHeight: "100vh",
    overflowX: "hidden",
    overflowY: "auto"
  };

  const pageBackground = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "white",
    zIndex: 0,
    pointerEvents: "none"
  };

  const thisContainer = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: "0px",
    minHeight: "100vh",
    position: "relative",
    zIndex: 1
  };

  const mainContent = {
	display:'flex',
    position: "fixed",
    left: "60px",
    top: "0px",
    right: "0px",
    bottom: "0px"
  };



  // ---------------- RENDER ----------------

  return (
    <div style={pageContainer}>

      <div style={pageBackground} />

      <div style={thisContainer}>

        <Header transitionHide={true}/>
        <LeftMenu />

        <div style={mainContent}>

          {/* 🏢 MAIN VIEWER */}
          <iframe
            ref={viewerRef}
            src="https://my.matterport.com/show/?m=8LGvarUFoVf&play=1&qs=1"
            style={{ width: "100%", height: "100%", border: "none" }}
          />

         </div>


      </div>
	  <div
	    onClick={() => setSearchOpen(!searchOpen)}
	    style={{
	      position: "fixed",
	      top: "310px",
	      right: "35px",
	      width: "44px",
	      height: "44px",
	      borderRadius: "50%",
	      background: "rgba(0,0,0,0.65)",
	      backdropFilter: "blur(6px)",
	      WebkitBackdropFilter: "blur(6px)",
	      display: "flex",
	      alignItems: "center",
	      justifyContent: "center",
	      cursor: "pointer",
	      zIndex: 9999,
	      color: "#fff",
	      border: "1px solid rgba(255,255,255,0.12)",
	      boxShadow: "0 6px 16px rgba(0,0,0,0.5)",
	      transition: "all 0.2s ease"
	    }}
	  >
	    <FontAwesomeIcon icon={faSearch} style={{ fontSize: "16px" }} />
	  </div>
	  <AssetSearchPanel
	    open={searchOpen}
	    setOpen={setSearchOpen}
	    onSelect={(asset) => {
	      setSearchAsset(asset);
	    }}
	  />
	  
	  <AssetDetailsDrawer
	    assetOpen={assetOpen}
	    assetCode={assetCode}
	    setAssetOpen={setAssetOpen}
	  />
	  <BuildingNavigator/>
    </div>
  );
  
  
}